import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import { ConfigurationSynopticTemplateResponse } from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template/configuration-synoptic-template.dto'
import { initialSynopticTemplatesModalExternalDocumentationState, SynopticTemplatesModalExternalDocumentationParams, SynopticTemplatesModalExternalDocumentationState } from '@/modules/configurationModule/detail/templates/synoptic-templates/components/modal-external-documentation/configuration-templates-synoptic-templates-modal-external-documentation.model'
import { configurationSynopticTemplateExternalDocumentationService } from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template-external-documentation/configuration-synoptic-template-external-documentation.service'
import { FileUtils } from '@/shared/util/file-utils'
import { PromiseUtils } from '@/shared/util/promise-utils'

@Component
export default class ConfigurationTemplatesSynopticTemplatesModalExternalDocumentation extends Vue {
    @Prop() readonly synopticTemplate!: ConfigurationSynopticTemplateResponse
    @Prop() readonly broadcastChannelPostMessageFunction!: Function

    @Ref() synopticTemplatesExternalDocumentationFileInput!:any

    state: SynopticTemplatesModalExternalDocumentationState
    constructor() {
        super()
        this.state = initialSynopticTemplatesModalExternalDocumentationState()
    }

    async mounted(): Promise<void> {
        await this.getExternalDocumentation()
    }

    get canExternalDocumentation(): boolean {
        return !!this.state.file?.name
    }

    private _getParams(): SynopticTemplatesModalExternalDocumentationParams {
        return {
            laboratoryId: this.synopticTemplate.laboratory.labId,
            synopticTemplateId: this.synopticTemplate.id
        }
    }

    async saveExternalDocumentation(): Promise<void> {
        const { synopticTemplateId, laboratoryId } = this._getParams()
        const response =
            await this.$_toCallUnique(
                configurationSynopticTemplateExternalDocumentationService.update(laboratoryId, synopticTemplateId, this.state.file!))
        if (response) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.synopticTemplateConfigurationUpdateExternalDocumentation'))

            this.state.hasInitialFile = true
            if (this.broadcastChannelPostMessageFunction) {
                this.broadcastChannelPostMessageFunction()
            }
        }
    }

    async deleteExternalDocumentation(): Promise<void> {
        if (this.state.hasInitialFile) {
            const { synopticTemplateId, laboratoryId } = this._getParams()
            const response =
                await this.$_toCallUnique(
                    configurationSynopticTemplateExternalDocumentationService.delete(laboratoryId, synopticTemplateId))
            if (response !== null) {
                this.$_showToastSuccess(this.$tc('configuration.toastMessages.synopticTemplateConfigurationDeleteExternalDocumentation'))
            }
        }

        this.synopticTemplatesExternalDocumentationFileInput.reset()
        this.state.hasInitialFile = false
        if (this.broadcastChannelPostMessageFunction) {
            this.broadcastChannelPostMessageFunction()
        }
    }

    async getExternalDocumentation(): Promise<void> {
        const { synopticTemplateId, laboratoryId } = this._getParams()
        const response =
            await this.$_toCallSecure(
                configurationSynopticTemplateExternalDocumentationService.get(laboratoryId, synopticTemplateId),
                error => PromiseUtils.handleAxiosError(error, [404]))
        if (response) {
            const blob = response.data
            if (blob) {
                this.synopticTemplatesExternalDocumentationFileInput.setFiles(
                    [new File([blob], FileUtils.getFilenameFromHeaderRequest(response))])
                this.state.hasInitialFile = true
            }
        } else {
            this.state.hasInitialFile = false
        }
    }
}
